<template>
    <div id="accessStoreManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <div class="clearfix">
            <el-form-item style="width:56%;margin-bottom:15px">
                <el-col class="searthPart fl" style="width:1120px"> 
                    <ul class="classic">
                        <li style="width: 13%" v-for="(item,index) in orderLists" :key="index" class="clearfix orderListsLi" @click="toViewOrder(item,index)" :class="{highLight:activeIndex === index}">
                            <span>{{item.name}}</span>
                            <span>{{item.number}}</span>
                        </li>
                    </ul>
                </el-col>
                <!-- <el-form-item class="fr">
                    <el-col style="text-align:right">
                        <el-button size="medium" type="success" v-if="basicsAuth.inboundAdd" @click="createOrder()">新建出入库</el-button>
                        <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                    </el-col>
                </el-form-item> -->
            </el-form-item>
            <el-form-item style="width:39%;margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                <el-button size="medium" type="success" v-if="basicsAuth.inboundAdd" @click="createOrder()">新建出入库</el-button>
                        <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 5px;" @click="refresh()"></i>
            </el-form-item>
        </div>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select v-model="searchForm.warehouseType" placeholder="出入仓库" clearable>
                    <el-option v-for="(item,index) in pickingList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.code" placeholder="小码编号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select filterable clearable v-model="searchForm.createUser" @change="changeCreateUser" :filter-method="PinyinMatch" placeholder="请选择操作人">
                    <el-option v-for="(item,index) in operatorUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select v-model="searchForm.supplierId" @change="changeSupplierId" :filter-method="PinyinMatch1" placeholder="请选择供应商" clearable filterable>
                    <el-option v-for="(item,index) in pickingSurply" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  class="hewidth">
                <el-select filterable v-model="searchForm.status" placeholder="状态" clearable>
                    <el-option v-for="(item,index) in statusList" 
                        :label="item.paraName" 
                        :value="item.paraValue" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:25%;margin-bottom:15px">
                <el-date-picker
                style="width: 100%;"
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            
        </el-form>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @row-click="goToDetail">
                    <el-table-column
                        align="center"
                        prop="code"
                        width="140"
                        label="出入库编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="type"
                        label="类型">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="warehouseType"
                        label="仓库">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="amount"
                        label="总金额"
                        :formatter="addCommas">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="supplierName"
                        label="供应商">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUser"
                        label="操作人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        width="155"
                        label="提交时间">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    // import {moment} from '@/moment.js'
    import {
        inboundList,
        selectParameterInfoBusiness,
        get_count,
        getsupplierList,
        queryUser
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    import PinyinMatch from 'pinyin-match';
    export default {
        name: 'accessStoreManage',
        components: {},
        data () {
            return {
                orderId:'',
                valueTime3:[],
                activeIndex: 0,
                copy:[],
                operatorUserAllList:[],
                orderLists:[
                    {
                        name: '全部',
                        number: 0,
                        status:''
                    },
                    {
                        name: '采购入库',
                        number: 0,
                        status:'CGRK'
                    },
                    {
                        name: '其它入库',
                        status:'QTRK',
                        number: 0,
                    },
                    {
                        name: '物料出库',
                        status:'WLCK',
                        number: 0,
                    },
                ],
                statusList:[
                    {
                        paraName:'已确认',
                        paraValue:'YQR'
                    },
                    {
                        paraName:'暂存',
                        paraValue:'save'
                    }
                ],
                copy1:[],
                pickingSurply:[],
                pickingList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    warehouseType:'',  //仓库类型
                    code: '',          //出入库编号
                    relatedId:'',      //采购订单编号
                    createUser: '',    //创建人
                    attribute1:'',     //创建开始时间
                    attribute2:'',     //创建结束时间
                    type:'',           //记录类型
                    supplierId:'',
                    status:'' 
                },
                returnData: [],
                basicsAuth:{
                    inboundAdd:false
                }
            }
        },
        created:function(){
            this.basicsAuth.inboundAdd = getPermission('/api/inbound/inboundAdd');
        },
        activated(){
            this.getCount();
            this.getInoundList();
            this.getSupplierListData();
            this.getSelectParameterInfoBusiness();
            this.getOperatorUserAllList();
        },
        mounted () {
        },
        methods: {
            //强制刷新
            changeCreateUser(e){
                console.log(e);
                this.searchForm.createUser = e;
                this.$forceUpdate();
            },
            changeSupplierId(e){
                console.log(e);
                this.searchForm.supplierId = e;
                this.$forceUpdate();
            },
            //操作人拼音模糊搜索
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.staffName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.createUser = val;
                    this.operatorUserAllList = result;
                }else{
                    this.operatorUserAllList = this.copy;
                    this.searchForm.createUser = "";
                }
            },
            //供应商拼音模糊搜索
            PinyinMatch1(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy1.forEach(i => {
                        let m = PinyinMatch.match(i.paraName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.supplierId = val;
                    this.pickingSurply = result;
                }else{
                    this.pickingSurply = this.copy1;
                    this.searchForm.supplierId = "";
                }
            },
            clearFrom(){
                this.searchForm = {
                    warehouseType:'',  //仓库类型
                    code: '',          //出入库编号
                    relatedId:'',      //采购订单编号
                    createUser: '',    //创建人
                    attribute1:'',     //创建开始时间
                    attribute2:'',     //创建结束时间
                    type:'',           //记录类型
                    supplierId:'',
                    status:''  
                };
                this.valueTime3 = [];
            },
            getOperatorUserAllList(){
                queryUser({type:2}).then(res => {     
                    if (res.data.status==100) {
                        this.operatorUserAllList = res.data.results;
                        this.copy = Object.assign(this.operatorUserAllList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取出入库记录数量
            getCount(){
                let para={};
                get_count(para).then(res => {          
                    if (res.data.status==100) {            
                        let arr = res.data.results
                        this.orderLists[0].number = arr.ALL
                        this.orderLists[1].number = arr.CGRK
                        this.orderLists[2].number = arr.QTRK
                        this.orderLists[3].number = arr.WLCK                  
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取出入仓库列表
            getSelectParameterInfoBusiness(){
                let para={
                    paraType: 'warehouse_type'
                }
                selectParameterInfoBusiness(para).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingList = res.data.results.list          
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取供应商下拉列表
            getSupplierListData(){
                getsupplierList({startRow:1,pageSize:10000}).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingSurply = res.data.results.list;
                        this.pickingSurply.forEach((item,index)=>{
                            item.paraName = item.supplierName
                            item.paraCode = item.id
                        });
                        this.copy1 = Object.assign(this.pickingSurply); //保留数据源          
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取出入库管理列表
            getInoundList(){
                let para={
                    sn: this.searchForm.code,
                    relatedId: this.searchForm.relatedId,
                    createUser: this.searchForm.createUser,
                    warehouseType: this.searchForm.warehouseType,     
                    type: this.searchForm.type,
                    supplierId:this.searchForm.supplierId,
                    attribute1: this.searchForm.attribute1,
                    attribute2: this.searchForm.attribute2,
                    status:this.searchForm.status,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                inboundList(para).then(res => {          
                    if (res.data.status==100) {            
                        this.returnData = res.data.results.list
                        this.returnData.forEach((item,index)=>{
                            item.createTime = this.filters.formatDate(item.createTime)
                        })
                        this.pages.total = res.data.results.total
                                 
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                //var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getInoundList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getInoundList()
            },
            //查看订单
            toViewOrder(item,index) {
                this.activeIndex = index
                this.searchForm.type = item.status
                this.getInoundList()
            },
            //进入详情页面
            goToDetail(row) {
                console.log(row)
                this.orderId = row.id;
                if(row.status == '暂存'){
                    this.$router.push({
                        path:'/editAccessStore',
                        query:{
                            orderId:this.orderId,
                            type:row.type,
                            warehouseType:row.warehouseType
                        }
                    })
                }else{
                    this.$router.push({
                        path:'/accessStoreInfo',
                        query:{
                          orderId:this.orderId
                        }
                    })
                }   
            },
            //新建采购订单
            createOrder() {
                this.$router.push({
                    path:'/newAccessStore'
                })
            },
            refresh() {
                this.activeIndex = 0;
                this.searchForm = {};
                this.getCount();
                this.getInoundList();
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                if (valid) {
                    if(this.valueTime3 == null){
                        this.searchForm.attribute1 = ''
                        this.searchForm.attribute2 = ''
                    }else if (this.valueTime3.length == 0) {
                        this.searchForm.attribute1 = ''
                        this.searchForm.attribute2 = ''
                    }else{
                        this.searchForm.attribute1 = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                        this.searchForm.attribute2 = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                    }
                    this.getInoundList()
                  
                } else {
                    console.log('验证未通过');
                    return false;
                }
              });
            },
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
  #accessStoreManage{font-size: 14px;
    .headerT{font-size: 16px;margin:0 0 15px 0;}
    .classic{
        display:flex;
    }
    .orderListsLi{
        border:1px solid #c6c6c6;
        border-radius: 5px;
        line-height: 35px;
        padding: 0 20px;
        cursor: pointer;
        margin-right:20px;
      & > span:first-child{float:left;}
      & > span:last-child{float:right;}
    }
    .orderListsLi.highLight{background-color: #1abc9c;border-color: #fff;color: #fff;}
    tr.el-table__row{cursor: pointer;}
    .toolbar{margin: 20px 0;}
    input.el-input__inner{padding-right:25px; }
    
  }
  #section {-webkit-box-shadow: 0px 0px 4px rgba(0,0,0,.2);box-shadow: 0px 0px 4px rgba(0,0,0,.2);padding: 15px 20px;margin-bottom: 15px;}
    #choose {margin: 0 auto;line-height: 24px;}
    #type {width: 100%;padding: 10px 0 16px 0px;}
    #type li {color: #8a8a8a;line-height: 34px;}
    #type a {margin: 0 12px 0 10px;color: #000;border:1px solid transparent;}
    #choose mark {
      position: relative;
      display: inline-block;
      height: 24px;
      line-height: 24px;
      border: 1px solid #28a5c4;
      color: #28a5c4;
      margin: -1px 5px 5px 0;
      background: none;
      padding: 0 30px 0 6px;
      text-indent: 0;
      /*top: 5px;*/
    }
    #choose mark a {
      position: absolute;
      /*top: -5px;*/
      right: 0px;
      display: inline-block;
      width: 18px;
      height: 22px;
      background: #28a5c4;
      color: #fff;
      line-height: 22px;
      font-size: 16px;
      text-align: center;
      }
      #type a.active {/*border:1px solid #1abc9c;*/color:#28a5c4;}
  .hewidth {
        width: 13% !important;
      }
</style>



// WEBPACK FOOTER //
// accessStoreManage.vue?7cac5e79